import styled from 'styled-components'

import colors from '@settings/styleSettings'

export const Container = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  height: 100%;
  text-align: center;
  align-items: center;
  justify-content: center;
  overflow-y: auto;
  overflow-x: hidden;
`

export const Title = styled.h1`
  font-size: 32px;
  font-weight: 700;
  line-height: 32px;
`

export const Description = styled.p`
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
  color: ${colors.strongGray};
`

export const Icon = styled.span`
  font-size: 64px;
  color: ${colors.strongGray};
`

export const ButtonContainer = styled.div`
  width: 250px;
  gap: 8px;
  display: flex;
  flex-direction: column;
  margin: auto;
`

export const FilesContainer = styled.div`
  width: 100%;
  height: 100%;
`

export const Identifier = styled.p`
  font-size: 20px;
  font-weight: 700;
  text-align: left;

  &:nth-child(2n + 1) {
    color: ${colors.strongGray};
  }
`

export const InputArea = styled.div`
  display: flex;
  flex: 2;
  align-items: center;
  justify-content: center;
  gap: 24px;
`

export const FileDetails = styled.li`
  display: flex;
  list-style-type: none;
  align-items: center;
  color: ${colors.strongGray};
  font-weight: bold;
`

export const Remove = styled.div`
  color: ${colors.strongGray};
  cursor: pointer;
  &:hover {
    color: ${colors.strongRed};
  }
`

export const StatusContainer = styled.div`
  display: flex;
  justify-content: flex-start;
`

export const ConfirmContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`
